import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import helpersNumbers from "../../../../helpers/numbers";
import helpersTime from "../../../../helpers/time";
import TitleBar from "../../../partials/content/TitleBar";
import TransactionCoworkerList from "./TransactionCoworkerList";

export default function AllTransactionCoworker() {
  const generateTransactionCoworker = () => {
    return (
      <div className="pt-2">
        <div className="alert alert-warning ">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p className="text-justify">
                در این بخش شما میتوانید موجودی حساب کاربران خود را افزایش یا
                کاهش دهید.
              </p>
            </li>
          </ul>
        </div>
        <div>
          <Link to="/finance/add-transaction" className="btn btn-success">
            <span className="d-flex align-items-center">
              <i className="fa fa-plus"></i>
              <span className="pr-2">تراکنش جدید</span>
            </span>
          </Link>
        </div>
        <br />
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space m-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تراکنش</td>
                <td>شماره کاربر</td>
                <td>نام کاربر</td>
                <td>مبلغ(تراکنش)</td>
                <td>عملیات</td>
                <td>تاریخ درج</td>
              </tr>
            </thead>
            <tbody>
              {TransactionCoworkerList.map((transaction, index) => {
                return (
                  <tr>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>{helpersNumbers.toPersianNum(transaction.id)}</td>
                    <td>{helpersNumbers.toPersianNum(transaction.user_id)}</td>
                    <td>{helpersNumbers.toPersianNum(transaction.name)}</td>
                    <td>
                      <span className="letter-spacing-finance-number">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(
                            transaction.amount
                          )
                        )}
                      </span>
                    </td>
                    <td>{generateTagOperation(transaction.operate)}</td>
                    <td>
                      {helpersNumbers.toPersianNum(transaction.created_at)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const generateTagOperation = (operate) => {
    let statusTagOperate = <></>;
    switch (operate) {
      case 1:
        statusTagOperate = (
          <span className="badge badge-success">اضافه کردن</span>
        );
        break;
      case 2:
        statusTagOperate = <span className="badge badge-danger">کسر کردن</span>;
        break;
    }
    return statusTagOperate;
  };

  const generateCustomerDoseNotHaveTransaction = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img
            class="img-fluid"
            src="/assets/img/do-not-have-transaction.svg"
          />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p className="text-justify">
            در این بخش شما میتوانید موجودی حساب کاربران خود را افزایش یا کاهش
            دهید.
          </p>
          <p className="text-justify">
            شما تاکنون انتقال اعتبار به کاربران خود نداشته اید و تاریخچه انتقال
            اعتبار شما خالی است.
          </p>
          <div>
            <Link
              to="/finance/coworker/add-transaction"
              className="btn btn-success"
            >
              <span className="d-flex align-items-center">
                <i className="fa fa-plus"></i>
                <span className="pr-2">تراکنش جدید</span>
              </span>
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar
        openItem="coworker-customer-finance"
        activeItem="all-transaction-coworker-customer"
      />

      <div className="content-wrapper">
        <TitleBar title="انتقال اعتبار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="list-customer">
              {generateTransactionCoworker()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
